<template>
  <div>
    <b-card header-text-variant="dark">
      <div slot="header">
        <context-header title="Dashboard"></context-header>
      </div>
      <div v-if="user">
        <b-row>
          <b-col cols="4">
            <h6>{{ $t('dashboard.welcome') }} {{user.name}}</h6>          
          </b-col>
        </b-row>
        <hr>
      </div>
        <div v-if="registration">
           <b-row>
            <b-col cols="4">
                <b-form-fieldset class="property-label-caption" :label="$t('userRegistration.registrationName')">
                    <label class="property-label">{{registration.name}}</label>
                </b-form-fieldset>
            </b-col>
            <b-col cols="4">
                <b-form-fieldset class="property-label-caption" :label="$t('userRegistration.registrationAddress')">
                    <label class="property-label">{{registration.address}}</label>
                </b-form-fieldset>
            </b-col>
            <b-col cols="4">
                <b-form-fieldset class="property-label-caption" :label="$t('userRegistration.registrationApprovedDate')">
                    <label class="property-label">{{formatDate(registration.registrationDate)}}</label>
                </b-form-fieldset>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4" v-if="isPublicEntity">
                <b-form-fieldset class="property-label-caption" :label="$t('userRegistration.registrationBudgetId')">
                    <label class="property-label">{{registration.companyNumber}}</label>
                </b-form-fieldset>
            </b-col>
            <b-col cols="4" v-if="isPrivateEntity">
                <b-form-fieldset class="property-label-caption" :label="$t('userRegistration.registrationCompanyNumber')">
                    <label class="property-label">{{registration.companyNumber}}</label>
                </b-form-fieldset>                
            </b-col>
            <b-col cols="4" v-if="isPrivateEntity">
                <b-form-fieldset class="property-label-caption" :label="$t('userRegistration.registrationTaxIdNumber')">
                    <label class="property-label">{{registration.taxIdNumber}}</label>
                </b-form-fieldset>
            </b-col>
        </b-row>    
        <b-row>          
            <b-col cols="4" v-if='registration.invoiceLimit'>
                <b-form-fieldset class="property-label-caption" :label="$t('dashboard.liabilitiesRegistrationLimit')">
                    <label class="property-label">{{registration.invoiceLimit}}</label>
                </b-form-fieldset>
            </b-col>
        </b-row>
      </div>
      <div v-if="liabilitiesTotal && !isAdmin">
        <hr>
        <b-row>
            <b-col cols="4">
                <b-form-fieldset class="property-label-caption" :label="$t('dashboard.liabilitiesRegisteredTotal')">
                    <label class="property-label">{{liabilitiesTotal.debtorInvoices + liabilitiesTotal.creditorInvoices}}</label>
                </b-form-fieldset>
            </b-col>          
            <b-col cols="4">
                <b-form-fieldset class="property-label-caption" :label="$t('dashboard.liabilitiesRegisteredDebtor')">
                    <label class="property-label">{{liabilitiesTotal.debtorInvoices}}</label>
                </b-form-fieldset>
            </b-col>          
            <b-col cols="4">
                <b-form-fieldset class="property-label-caption" :label="$t('dashboard.liabilitiesRegisteredCreditor')">
                    <label class="property-label">{{liabilitiesTotal.creditorInvoices}}</label>
                </b-form-fieldset>
            </b-col>                      
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import { getOrganizationId, hasAdminClaim } from '@/router/auth'

  export default {
    name: 'dashboard',
    components: {
      ContextHeader
    },
    data () {
      return {
        isAdmin: false,
        user: null,
        registration: null,
        liabilitiesTotal: null,
        organizationLink: '',
        organizationId: null
      }
    },
    computed: {
      isPublicEntity () {
        if (!this.registration || !this.registration.companyNumber) { return false }
        return this.registration.companyNumber.length === 5
      },
      isPrivateEntity () {
        if (!this.registration || !this.registration.companyNumber) { return false }
        return this.registration.companyNumber.length === 8
      }
    },
    created () {
      this.logConsole('Dashboard created')
      this.organizationId = parseInt(getOrganizationId())
      this.isAdmin = hasAdminClaim()

      this.$http.get(Vue.$apiConfig.summaryInfoGet)
        .then(response => {
          this.logConsole(response)
          let summary = response.data.payload
          this.user = summary.user
          this.registration = summary.registration
          this.organizationLink = '/user-registration/approval/' + this.user.organizationId
          this.createLiabilitySummary(summary.liabilities)

          let notifications = summary.notifications
          if (notifications.length > 0) {
            EventBus.$emit('notification', notifications)
          }
        }, error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
        })
    },
    methods: {
      createLiabilitySummary (liabilities) {
        this.liabilitiesTotal = liabilities
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';

  .bg-primary {
    background-color: $primary-color-accent !important;
  }
  
  .property-label {
    font-size: 11pt;
    font-weight: 400;
  }

  .property-label-caption {
    font-size: 12pt;
    font-weight: 600;
  }

  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }
  
</style>



// WEBPACK FOOTER //
// Dashboard.vue?250f2ada